<template>
  <div>
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-if="!loading">
      <div class="container-fluid">
        <div
          v-if="!(errorMessage == '' || errorMessage == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ errorMessage }}</strong>
        </div>
        <div v-else>
          <center class="loading-medium" v-if="ConfirmLoading">
            <loading></loading>
          </center>
          <div v-if="successMessage != null && successMessage != ''">
            <div class="alert alert-success text-center">
              <strong>{{ successMessage }}</strong>
            </div>
          </div>
          <!-- <div
            v-if="!(pageError == '' || pageError == null)"
            class="alert alert-danger text-center custom-width alert-custom"
          >
            <strong>{{ pageError }}</strong>
          </div> -->
          <div
            v-if="!(ConfirmError == '' || ConfirmError == null)"
            class="alert alert-danger text-center custom-width alert-custom"
          >
            <strong>{{ ConfirmError }}</strong>
          </div>
          <div class="row">
            <div class="col-xs-3">
              <h3>Completed Requests</h3>
            </div>
            <div class="col-xs-6"></div>
            <div class="col-xs-3">
              <img
                :src="BankLogo"
                style="
                  height: 44px;
                  width: 195px;
                  float: right;
                  margin-left: 20px;
                  margin-right: 20px;
                "
              />
            </div>
          </div>
          <div
            v-if="!(userBank.Name == null || userBank.Name == '')"
            class="row"
          >
            <div class="col-md-6">
              <h3>{{ userBank.Name }}</h3>
            </div>
            <div class="col-md-6 text-right">
              <img
                style="padding: 10px"
                src="../../assets/imgs/BIsBR.png"
                v-hide="!(userBank.Name == null || userBank.Name == '')"
              />
            </div>
          </div>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control search-box"
              style="background-color: white"
              placeholder="Search"
              v-model="Search"
            />
            <date-pick
              style="margin-left: 4px"
              v-model="startdate"
              :format="'DD-MM-YYYY'"
              :inputAttributes="{
                class: 'form-control',
                placeholder: 'From Date',
              }"
            ></date-pick>
            <date-pick
              style="margin-left: 4px"
              v-model="enddate"
              :format="'DD-MM-YYYY'"
              :inputAttributes="{
                class: 'form-control',
                placeholder: 'To Date',
              }"
            ></date-pick>

            <select
              class="form-control"
              v-model="Status"
              style="margin-left: 5px"
            >
              <option value>All</option>
              <option value="1">Completed Requests</option>
              <option value="2">Pending Request</option>
              <option value="3">Cancelled</option>
            </select>
            <a
              href="javascript:void(0)"
              class="btn btn-primary"
              style="margin-left: 4px"
              @click="Filter"
              >Filter</a
            >
          </div>
          <div v-bind:id="'printable'" style="overflow-x: scroll">
            <strong v-currentdate>Current Date Time</strong>
            <table class="table table-bordered ng-grid" style="width: 100%">
              <thead style="background: #efeeed">
                <tr>
                  <th>No.</th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('RefNo')"
                      >Ref No</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'RefNo'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('BankReference')"
                      >Your Reference</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'BankReference'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ClientName')"
                      >Client Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ClientName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('TransferOwner')"
                      >New Owner</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'TransferOwner'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('DepartmentName')"
                      >Department Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'DepartmentName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <!-- <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('TransferOwner')">New Owner</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='TransferOwner'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>-->
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ApplicationDate')"
                      >Transaction Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ApplicationDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ValueDate')"
                      >Value Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ValueDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>

                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('MaturityDate')"
                      >Maturity Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'MaturityDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Amount')"
                      >Amount</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Amount'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>Commission</th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('CommodityName')"
                      >Commodity</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'CommodityName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('Quantity')"
                      >Quantity</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Quantity'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('RequesterName')"
                      >Requested By</a
                    >
                    <span
                      class="sortorder"
                      @click="ChangeOrder('RequesterName')"
                      v-show="currentSort == 'RequesterName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>Physical Delivery</th>
                  <th class="Print">Status</th>
                  <th
                    class="Print"
                    v-if="RoleId == 1 || RoleId == 5 || RoleId == 4"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(option, index) in OrderBy"
                  :key="index"
                  :class="{ even: index + (1 % 2) == 0 }"
                >
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{
                      (SelectedPageSize == "ALL" ? 0 : SelectedPageSize) *
                        (currentPage - 1) +
                      (index + 1)
                    }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.RefNo }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.BankReference }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.ClientName }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.TransferOwner }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.DepartmentName }}
                  </td>
                  <!-- <td>{{option.TransferOwner}}</td> -->
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ DateFromat(option.ApplicationDate) }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ DateFromat(option.ValueDate) }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ DateFromat(option.MaturityDate) }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    <span class="green" style="float: left">
                      {{ option.CurrencyShortname }}
                      <br />
                      {{ option.StringAmount }}
                    </span>
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                    v-if="option.CurrencyShortname == 'SAR'"
                  >
                    <span class="green" style="float: left">
                      {{ option.CurrencyShortname }}
                      <br />
                      {{ option.SARCommission }}
                    </span>
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                    v-else
                  >
                    <span class="green" style="float: left">
                      {{ option.CurrencyShortname }}
                      <br />
                      {{ option.USDCommission }}
                    </span>
                  </td>

                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.CommodityName }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.StringQuantity }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    {{ option.RequesterName }}
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                  >
                    <span v-if="option.PhysicalDelivery">Yes</span>
                    <span v-else>No</span>
                  </td>
                  <td
                    @click="openViewModal(option.RequestId, option.Cancelled)"
                    class="img Print"
                  >
                    <span v-if="option.Cancelled == 'Y'">Cancelled</span>
                    <span v-else-if="option.Sell">Completed</span>
                    <span v-else>Pending</span>
                  </td>
                  <td
                    class="img Print"
                    v-if="RoleId == 1 || RoleId == 5 || RoleId == 4"
                  >
                    <a
                      href="javascript:void(0)"
                      title="Edit User"
                      @click="MakeAvailableForEdit(option.RequestId)"
                    >
                      <img src="../../assets/imgs/png/Action.png" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />
          <div class="custom-width">
            <div class="pull-left">
              <paginate
                ref="paginate"
                :page-count="PageCalculation"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :click-handler="clickCallback"
                :container-class="'pagination'"
              ></paginate>
            </div>
            <div class="btn-group form-inline pull-right pager">
              <label>Page Size :</label>
              <select
                v-model="SelectedPageSize"
                class="form-control input-sm"
                @change="ChangePageSizeORSearch"
              >
                <option v-for="(option, index) in PageSize" :key="index">
                  {{ option.key }}
                </option>
              </select>
            </div>
          </div>
          <pre class="custom-width">
Page:{{ currentPage }} / {{ PageCalculation }} </pre
          >
        </div>
      </div>
    </div>
    <viewrequest
      v-if="viewmodal"
      :RequestId="RequestId"
      @Close="CloseModal"
      @Edit="EditRequest"
    ></viewrequest>
    <buyrequest
      v-if="showModal"
      :RequestId="RequestId"
      @Close="CloseModal"
    ></buyrequest>
    <modal v-if="EditConfirm">
      <div slot="header">
        <h3>Edit Transaction</h3>
      </div>
      <div slot="body">
        are you sure you want to make available to edit this Transaction?
      </div>
      <div slot="footer">
        <button class="btn btn-danger" @click="MakeAvailableForEditConfirm">
          Yes, Confirm
        </button>
        <button class="btn btn-warning" @click="GoBack">Back</button>
      </div>
    </modal>
  </div>
</template>

<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import viewrequest from "./ViewBuyRequest";
import buyrequest from "./buyRequests";
import DatePick from "vue-date-pick";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      currentPage: 1,
      viewmodal: false,
      Status: 1,
      startdate: null,
      enddate: null,
      showModal: false,
      RequestId: null,
      Search: null,
      currentSort: "RefNo",
      curentSortOrder: "desc",
      userBank: { Name: null },
      EditConfirm: false,
      successMessage: null,
      pageError: null,
    };
  },
  components: {
    viewrequest,
    DatePick,
    buyrequest,
  },
  methods: {
    GoBack() {
      this.RequestId = null;
      this.EditConfirm = false;
    },
    MakeAvailableForEdit(RequestId) {
      this.RequestId = RequestId;
      this.EditConfirm = true;
    },
    MakeAvailableForEditConfirm() {
      this.EditConfirm = false;
      if (this.RequestId == 0 || this.RequestId == null) {
        return;
      }
      var vm = this;
      var Url = "EditTransaction?RequestId=" + this.RequestId;
      vm.$store
        .dispatch(ACTIONS.CONFIRM_EDIT_TRANSACTION, Url)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            vm.successMessage = data.StatusMessage;
            setTimeout(function () {
              vm.successMessage = null;
              vm.GetData();
            }, 2500);
          } else if (
            data &&
            (data.StatusCode == 500 ||
              data.StatusCode == 403 ||
              data.StatusCode == 2 ||
              data.StatusCode == 429 ||
              data.StatusCode == 1 ||
              data.StatusCode == 406 ||
              data.StatusCode == 0)
          ) {
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    EditRequest() {
      this.viewmodal = false;
      this.showModal = true;
    },
    openViewModal(id, Cancelled) {
      if (Cancelled == "Y") {
        return;
      }
      this.RequestId = id;
      this.viewmodal = true;
    },
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function (page) {
      if (page) {
        this.currentPage = page;
        this.ListAcceptedId = [];
        this.ChnageUrl();
        this.GetData();
      }
    },
    CheckDates() {
      if (this.startdate == "") {
        this.startdate = null;
      }
      if (this.enddate == "") {
        this.enddate = null;
      }
    },
    CloseModal() {
      this.RequestId = null;
      this.viewmodal = false;
      this.showModal = false;
      this.GetData();
    },
    openModal(id) {
      this.RequestId = id;
      this.viewmodal = true;
    },
    Filter() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },
    ChnageUrl() {
      this.CheckDates();
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort +
        "&fromdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&todate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate)) +
        "&status=" +
        (this.Status == null ? "" : this.Status);
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ListAcceptedId = [];
      this.ChnageUrl();
      this.GetData();
    },

    GetData() {
      this.CheckDates();
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&startdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&enddate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate)) +
        "&status=" +
        (this.Status == null ? "" : this.Status);

      var vm = this;
      this.$store
        .dispatch(ACTIONS.COMPLETED_REQUEST_GET_ALL, Url)
        .then((res) => {
          this.$refs.paginate.selected = vm.currentPage - 1;
          // vm.ListAcceptedId = [];
          // var { data } = res;

          // if (data && data.StatusCode == 200) {
          //   var { buyRequests } = data.ResponseData;
          //   vm.selectList = buyRequests.map(a => a.RequesterAccepted);
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
      if (
        this.$route.query.hasOwnProperty("fromdate") &&
        this.$route.query["fromdate"] != null &&
        this.$route.query["fromdate"] != ""
      ) {
        this.startdate = this.setFormDate(this.$route.query["fromdate"]);
      }
      if (
        this.$route.query.hasOwnProperty("todate") &&
        this.$route.query["todate"] != "" &&
        this.$route.query["todate"] != null
      ) {
        this.enddate = this.setFormDate(this.$route.query["todate"]);
      }
      if (this.$route.query.hasOwnProperty("status")) {
        this.Status = this.$route.query["status"];
      }
    }

    this.GetData();
  },
  computed: {
    ...mapGetters({
      PageSize: "PageSize",
      Request: "GETCOMPLETEDREQUEST",
      TotalRecords: "GETCOMPLTEDTOTALPAGES",
      errorMessage: "GETCOMPLETEDREQUESTERROR",
      loading: "GETCOMPLETEDREQUESTLOADING",
      BankLogo: "GETBANKLOGO",
      RoleId: "RoleId",
      ConfirmLoading: "GETCONFIRMEDITLOADING",
      ConfirmError: "GETCONFIRMEDITERROR",
      //  UserDept: "deptId"
    }),
    OrderBy() {
      var data = [...this.Request];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      // this.selectList = [];
      // for (var i = 0; i < SortedArray.length; i++) {
      //   this.selectList.push({
      //     value: SortedArray[i].Accepted,
      //     id: SortedArray[i].RequestId,
      //     accpted: SortedArray[i].Accepted
      //   });
      // }
      if (!this.SelectedPageSize || this.SelectedPageSize == "ALL") {
        this.SelectedPageSize = SortedArray.length;
      }
      if (!this.currentPage) {
        this.currentPage = 1;
      }

      var sp = parseInt(this.SelectedPageSize); // selected Page
      var cp = parseInt(this.currentPage); // current page
      return this.Pagination(SortedArray, sp, cp);
      //return SortedArray;
    },
    PageCalculation() {
      var count = Math.ceil(this.TotalRecords / this.SelectedPageSize);
      return count > 0 ? count : 1;
    },
  },
};
</script>